var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"color":"primary","loading":_vm.loading,"large":""},on:{"click":function($event){return _vm.$emit('click')}}},[_c('span',{staticClass:"d-none d-sm-block"},[_vm._v(" "+_vm._s(_vm.$t('common.search'))+" ")]),_c('v-icon',{attrs:{"right":""}},[_vm._v(" mdi-keyboard-return ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }